import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VizHttpStatusComponent } from '@vizientinc/design-system-toolkit';
import { FooterComponent } from '../shared/components/footer/footer.component';
import { filter } from 'rxjs';

@Component({
    selector: 'app-error',
    imports: [
      VizHttpStatusComponent,
        FooterComponent
    ],
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss'
})
export class ErrorComponent implements OnInit {
  errorNumber: string = '404';

  get errorHeading(): string {
    return this.errorNumber === '404' ? 'Page Not Found' : 'Something Went Wrong';
  }

  readonly errorDescription = 'Please contact suppliertraining@vizientinc.com if the problem persists.';

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.params.pipe(
        filter(params => +params.errorNumber >= 400 && +params.errorNumber < 600)
    ).subscribe(params => {
      this.errorNumber = params.errorNumber;
    });
  }
}
